// @flow

import React from "react";
import { getClassName } from "ui-kit/utils/component";

import "./Footer.scss";

const ccn = getClassName("Footer");

const Footer = (props) => (
  <div className={ccn()}>
    <div className={ccn("container")}>
      <h2>© Ternary Intelligence Inc. All rights reserved.</h2>
    </div>
  </div>
);


export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js